!(function () {
  "use strict";
  var e = {
      4105: function (e, t, o) {
        o.d(t, {
          gp: function () {
            return c;
          },
          hO: function () {
            return n;
          },
        });
        const n = function () {
          let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = window.innerWidth - document.body.offsetWidth;
          const o = document.getElementById("nav-wrapper");
          e
            ? (document.body.classList.add("no-scroll"),
              (document.body.style.paddingRight = t + "px"),
              (o.style.paddingRight = t + "px"))
            : (document.body.classList.remove("no-scroll"),
              (document.body.style.paddingRight = "0px"),
              (o.style.paddingRight = "0px"));
        };
        let r = () => {},
          d = (e) => {
            "Escape" === e.key &&
              (r(), window.removeEventListener("keydown", d));
          };
        const c = function () {
          let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments.length > 1 ? arguments[1] : void 0;
          t && (r = t),
            e && window.addEventListener("keydown", d),
            e || window.removeEventListener("keydown", d);
        };
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, t, o, n) {
                return (e /= n / 2) < 1
                  ? (o / 2) * e * e + t
                  : (-o / 2) * (--e * (e - 2) - 1) + t;
              };
              const t = document.getElementById("grid-archive-header"),
                o = document.getElementById("nav-wrapper");
              let n = 0;
              t && (n = t.offsetHeight + 50),
                o && (navWrapperOffset = o.offsetHeight + 50);
              const r = e.offsetTop - n - navWrapperOffset,
                d = window.scrollY,
                c = r - d;
              let i = 0;
              const l = () => {
                i += 5;
                const e = Math.easeInOutQuad(i, d, c, 200);
                window.scrollTo(0, e), i < 200 && setTimeout(l, 5);
              };
              l();
            })(document.querySelector(t));
          });
        });
      },
    },
    t = {};
  function o(n) {
    var r = t[n];
    if (void 0 !== r) return r.exports;
    var d = (t[n] = { exports: {} });
    return e[n](d, d.exports, o), d.exports;
  }
  (o.d = function (e, t) {
    for (var n in t)
      o.o(t, n) &&
        !o.o(e, n) &&
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
  }),
    (o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = o(4105);
      const t = document.querySelector(".pdp-lightbox"),
        n = t.querySelector(".pdp-lightbox__close"),
        r = t.querySelectorAll("iframe, video"),
        d = () => {
          (0, e.hO)(!1),
            (0, e.gp)(!1),
            t.classList.remove("pdp-lightbox--open"),
            Array.prototype.forEach.call(r, function (e) {
              if ("video" === e.tagName.toLowerCase()) e.pause();
              else {
                var t = e.src;
                e.src = t;
              }
            });
        };
      n.addEventListener("click", () => {
        d();
      }),
        t.querySelectorAll(".figure--image").forEach((e) => {
          e.addEventListener("click", d);
        }),
        window.addEventListener("load", function () {
          document.querySelector(".product-converter__gallery").swiper ||
            document
              .querySelectorAll(
                ".product-converter__gallery figure:not(.figure--model)"
              )
              .forEach((o) => {
                o.addEventListener("click", () => {
                  var n;
                  (n = o.parentNode.getAttribute("data-id")),
                    (0, e.hO)(!0),
                    (0, e.gp)(!0, d),
                    t.classList.add("pdp-lightbox--open"),
                    ((e) => {
                      t.scrollTop =
                        t.querySelector('figure[data-id="' + e + '"')
                          .offsetTop + parseInt(getComputedStyle(t).paddingTop);
                    })(n);
                });
              });
        });
    })();
})();
